import { focusRing } from './SiteHeader';

export function Attribution({ className = '' }: { className?: string }) {
  return (
    <a
      href="https://rokass.org/work/memory-globe/"
      className={`inline-flex min-h-9 items-center pointer-coarse:min-h-11 gap-1.5 font-mono text-[10px] uppercase tracking-[0.14em] text-white/55 hover:text-[#f2c66d] ${focusRing} ${className}`}
    >
      A project by Rokas Šileikis <span aria-hidden="true">↗</span>
    </a>
  );
}
